(function () {
  var STORAGE_KEY = 'wishlist_count';
  var toastTimeout;
  var count = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);

  // --- Heart icon state ---

  function getIcon() {
    return document.querySelector('.header__wishlist .header__icon--wishlist');
  }

  function updateHeart() {
    var icon = getIcon();
    if (!icon) return;

    if (count > 0) {
      icon.classList.add('wishlist-icon--active');
    } else {
      icon.classList.remove('wishlist-icon--active');
    }
  }

  function shakeHeart() {
    var icon = getIcon();
    if (!icon) return;

    icon.classList.remove('wishlist-icon--shake');
    void icon.offsetWidth;
    icon.classList.add('wishlist-icon--shake');

    icon.addEventListener('animationend', function () {
      icon.classList.remove('wishlist-icon--shake');
    }, { once: true });
  }

  // --- Toast ---

  function showToast(message, type) {
    var toast = document.getElementById('wishlist-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.remove('wishlist-toast--hidden', 'wishlist-toast--success', 'wishlist-toast--remove');
    toast.classList.add('wishlist-toast--visible', type === 'remove' ? 'wishlist-toast--remove' : 'wishlist-toast--success');

    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(function () {
      toast.classList.remove('wishlist-toast--visible');
      toast.classList.add('wishlist-toast--hidden');
    }, 3000);
  }

  // --- Click handler ---

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gw-toggle-wishlist-product-card-button');
    if (!btn) return;

    // Read state before Growave toggles it — true means currently in wishlist (removing)
    var wasInWishlist = btn.getAttribute('data-in-wishlist') === 'true';
    var type = wasInWishlist ? 'remove' : 'add';
    var message = wasInWishlist ? 'Product removed from wishlist' : 'Product added to wishlist';

    count = Math.max(0, count + (type === 'add' ? 1 : -1));
    localStorage.setItem(STORAGE_KEY, count);

    setTimeout(function () {
      updateHeart();
      shakeHeart();
      showToast(message, type);
    }, 50);
  });

  // --- Init ---

  document.addEventListener('DOMContentLoaded', function () {
    updateHeart();
  });
})();
